export default "/_next/static/c8f686ee92c8e7360c5c2203d0291913.png";